import {
  Button,
  Column,
  Copy,
  Flex,
  Heading,
  Row,
  Stack,
  SvgPencil,
} from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';
import { PageSection } from 'src/components/selfService/layout/PageSection/PageSection';
import { PageSectionTitle } from 'src/components/selfService/layout/PageSectionTitle/PageSectionTitle';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import { SelfServiceCorp } from 'src/types/Corp';

export interface AccountCorporateSectionProps {
  corp: SelfServiceCorp;
  onEditClick: () => void;
}

function getAddress(corp: SelfServiceCorp) {
  return `${corp.location.address}, ${corp.location.city}, ${corp.location.state} ${corp.location.zip} `;
}

function getAdminName(corp: SelfServiceCorp) {
  return `${corp.adminInfo.first_name} ${corp.adminInfo.last_name}`;
}

function getAdminEmail(corp: SelfServiceCorp) {
  return corp.adminInfo.email;
}

function getPhone(corp: SelfServiceCorp) {
  return corp.location.phone;
}

export const AccountCorporateSection: React.FC<AccountCorporateSectionProps> =
  ({ corp, onEditClick }) => {
    const { isDesktop } = useScreenSizes();

    return (
      <PageSection dataTestId="account-corporate-section">
        <Row>
          <Column tablet={12} desktop={9}>
            <PageSectionTitle title={corp.name} />
            <Row>
              <Column tablet={12} desktop={6}>
                <Stack y="xxx-sm">
                  <Heading variant="h5" color="secondaryText">
                    Admin
                  </Heading>
                </Stack>
                <Stack y="md">
                  <Copy variant="body">{getAdminName(corp)}</Copy>
                </Stack>
                <Stack y="xxx-sm">
                  <Heading variant="h5" color="secondaryText">
                    Address
                  </Heading>
                </Stack>
                <Stack y={isDesktop ? 'none' : 'md'}>
                  <Copy variant="body">{getAddress(corp)}</Copy>
                </Stack>
              </Column>
              <Column tablet={12} desktop={6}>
                <Stack y="xxx-sm">
                  <Heading variant="h5" color="secondaryText">
                    Email
                  </Heading>
                </Stack>
                <Stack y="md">
                  <Copy variant="body">{getAdminEmail(corp)}</Copy>
                </Stack>
                <Stack y="xxx-sm">
                  <Heading variant="h5" color="secondaryText">
                    Phone
                  </Heading>
                </Stack>
                <Stack y={isDesktop ? 'none' : 'md'}>
                  <Copy variant="body">{getPhone(corp)}</Copy>
                </Stack>
              </Column>
            </Row>
          </Column>
          <Column tablet={12} desktop={3}>
            <Flex justifyContent="flex-end">
              <Button
                variant="secondary"
                buttonSize="medium"
                block={!isDesktop}
                onClick={onEditClick}
              >
                <Flex alignItems="center" justifyContent="center" height="100%">
                  <Stack x="x-sm" alignItems="center">
                    <SvgPencil size="20px" />
                  </Stack>
                  Edit
                </Flex>
              </Button>
            </Flex>
          </Column>
        </Row>
      </PageSection>
    );
  };
